/* global firebase */

import React, { Component } from "react";
import { connect } from "react-redux";
import jwt from "jsonwebtoken";
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import theme from "../utils/theme";

const circularProgressWidth = 40;
const loadingPanelLeftAdjust = (theme.sizes.navBarWidth - circularProgressWidth)/2;
const loadingPanelTopAdjust = circularProgressWidth/2;

const styles = theme => ({
  pageTitle: {
    fontWeight: "bold",
    fontSize: "1.6em",
    marginBottom: theme.spacing(2)
  },
  paper: {
    padding: '0px', 
    height: "calc(100vh - 100px)",
  },
  dataStudioIFrame: {
    position: "relative",
    width: '100%',
    height: '100%',
    borderRadius: "4px",
  },
  loadingPanel: {
    position: 'absolute',
    left: `calc(50vw + ${loadingPanelLeftAdjust}px)`,
    top: `calc(50vh - ${loadingPanelTopAdjust}px)`
  }
});

export class analyticsDashboardPage extends Component {
  constructor(props) {
    super(props);
    this.state = { frameUrl: '' };
    this.getIFrameUrl();
  }

  render() {
    const { classes } = this.props;
    return (

      <div>
        <Grid container justify="space-between">
          <Grid item xs={8}>
            <Typography variant="h5" className={classes.pageTitle}>
              Analytics
            </Typography>
          </Grid>
        </Grid>

        <Paper className={classes.paper}>
          <div style={{ overflow: 'hidden', height: '100%' }}>
            <div style={{ height: 'calc(100% + 24px)' }}>
              <div className={classes.loadingPanel}>
                <CircularProgress />
              </div>
              <iframe    
                src={this.state.frameUrl}
                frameBorder="0"
                className={classes.dataStudioIFrame}
              />
            </div>
          </div>
        </Paper>
      </div>
    );
  }

  getIFrameUrl = async () => {    
    let getAnalyticsFrameUrl = firebase.functions().httpsCallable('getAnalyticsFrameUrl');
    let result = await getAnalyticsFrameUrl();
    if (result.data.url) {
      this.setState({ frameUrl: result.data.url });
    }
  }
}

const mapStateToProps = state => ({
  curentUser: state.user.user
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(analyticsDashboardPage));
